type Payload = {
  event: string;
  [x: string]: any;
};

export const trackEventGTM = (payload: Payload) => {
  const windowAsAny = window as any;
  windowAsAny.dataLayer && windowAsAny.dataLayer.push(payload);
};
